import { useParams } from 'react-router-dom'

import Header from '../../containers/Header'
import Menu from '../../components/Menu'

import * as S from './styles'
import * as Txt from '../../styles/text'
import { AtividadesCard } from '../../components/AdminTurmaCard/styles'

import { useGetTurmaByIdQuery } from '../../services/api'

const TurmaDetalhes = () => {
  const { id } = useParams()
  const { data: turma } = useGetTurmaByIdQuery(id!)
  console.log(turma)

  if (!turma) return <div>Carregando...</div>

  return (
    <>
      <Header />
      <Menu />
      {/* Mobile aqui */}
      <div className="p-4">
        <S.CardDetalhes className="container p-4 rounded-4 mt-4 col-md-7 col-lg-5 d-md-none">
          <S.DetalhesTitle>{turma.nome_turma}</S.DetalhesTitle>
          <img src={turma.imagem_url} alt="" className="w-100 rounded-3 mt-3" />
          <p className="text-center mt-3 sm-fs-3">{turma.objetivo}</p>
          <h5 className="text-center mt-4 fw-bold">
            O que será desenvolvido na turma:
          </h5>
          <p className="text-center mt-3 sm-fs-3">{turma.desenvolver}</p>
          <ul className="ps-0">
            {Array.isArray(turma.atividades) && turma.atividades.length > 0 ? (
              <>
                <h5 className="text-center mt-4 mb-3 fw-bold">
                  Atividades propostas:
                </h5>
                {turma.atividades.map((atividade) => (
                  <li key={atividade.id}>
                    <AtividadesCard>
                      <Txt.TitleMd className="text-center fw-bold">
                        {atividade.titulo_ativ}
                      </Txt.TitleMd>
                      <p className="text-center mt-2">{atividade.desc_ativ}</p>
                    </AtividadesCard>
                  </li>
                ))}
              </>
            ) : (
              <></>
            )}
          </ul>
        </S.CardDetalhes>

        {/* Telas maiores aqui */}
        <S.CardDetalhes className="container p-4 rounded-4 mt-4 col-md-8 col-lg-12 d-none d-md-flex flex-row">
          <S.ResponsiveTitleImageDiv>
            <S.ResponsiveDetalhesTitle>
              {turma.nome_turma}
            </S.ResponsiveDetalhesTitle>
            <img src={turma.imagem_url} alt="" />
          </S.ResponsiveTitleImageDiv>
          <S.ResponsiveCardContent>
            <p className="text-center mt-3 sm-fs-3">{turma.objetivo}</p>
            <h5 className="text-center mt-4 fw-bold">
              O que será desenvolvido na turma:
            </h5>
            <p className="text-center mt-3 sm-fs-3">{turma.desenvolver}</p>
            <ul className="ps-0">
              {Array.isArray(turma.atividades) &&
              turma.atividades.length > 0 ? (
                <>
                  <h5 className="text-center mt-4 mb-3 fw-bold">
                    Atividades propostas:
                  </h5>
                  {turma.atividades.map((atividade) => (
                    <li key={atividade.id}>
                      <AtividadesCard>
                        <Txt.TitleMd className="text-center fw-bold">
                          {atividade.titulo_ativ}
                        </Txt.TitleMd>
                        <p className="text-center mt-2">
                          {atividade.desc_ativ}
                        </p>
                      </AtividadesCard>
                    </li>
                  ))}
                </>
              ) : (
                <></>
              )}
            </ul>
          </S.ResponsiveCardContent>
        </S.CardDetalhes>
      </div>
    </>
  )
}

export default TurmaDetalhes
